import React from 'react';
import { IonModal, IonButton, IonIcon } from '@ionic/react';
import { close } from 'ionicons/icons';

import './index.css';

export default class Modal extends React.Component {
  render() {
    const { children, title, action, actionLabel, className, scrollable, ...rest } = this.props;
    const { onDidDismiss } = rest;

    return (
      <IonModal className={'modal-classic modal-wrapper' + (className ? ' ' + className : '')} {...rest}>
        <div className={'modal-classic-wrapper' + (scrollable ? ' scrollable-y' : '')}>
          {onDidDismiss ? (
            <div className="modal-classic-closer" onClick={onDidDismiss}>
              <IonIcon
                icon={close}
              />
            </div>
          ) : null}
          {title ? (
            <div className="modal-classic-header">
              <h3>{title}</h3>
            </div>
          ) : null}
          <div className="modal-classic-content">{children}</div>
          {action ? (
            <div className="modal-classic-action">
              <IonButton expand="block" color="primary" onClick={action}>
                {actionLabel || '--'}
              </IonButton>
            </div>
          ) : null}
        </div>
      </IonModal>
    );
  }
}
